import SectionHeading from "./SectionHeading";
import { columns } from "@/mocks/columns";

export default function ColumnSection() {
  return (
    <section id="columns" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="核查栏目"
          title="六道工序，拆穿每一层伪装"
          desc="从单条甄别到量化评分，我们用统一的核查方法处理流传的在线黑料，让结论有出处、可复核。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {columns.map((c) => (
            <article
              key={c.title}
              className="group rounded-lg border border-background-200 bg-background-100/60 p-6 hover:border-primary-200 hover:bg-background-100 transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className={`${c.icon} text-xl`}></i>
                </span>
                <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium">
                  {c.tag}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                {c.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-700">{c.desc}</p>
              <a
                href="#reports"
                className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 whitespace-nowrap"
              >
                了解如何判定
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}